import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FileService {
    constructor(private http: HttpClient) { }

    downloadFile(filename: string) {
        return this.http.get(`${environment.apiUrl}/iintegration/media/${filename}`, {
            responseType: 'blob'
        });
    }
}
